import { render, staticRenderFns } from "./CallDurationBarChart.vue?vue&type=template&id=5503beb6&"
import script from "./CallDurationBarChart.vue?vue&type=script&lang=js&"
export * from "./CallDurationBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports